import SidePanelSection from '../../../../../../components/sidepanel-section';
import { LinksProps } from './LinksProps';
import { LinksInner } from './LinksInner';
import { P2GBox } from '@parcel2go/core-ui';
import { LabelLinks } from './LabelLinks';
import { LinkModel } from './LinkModel';

type props = LinksProps & { wrapper?: (children: React.ReactNode) => React.ReactNode };

const Inner = (props: LinksProps & { links: LinkModel[] }) => {
  if (props.variant === 'label') {
    return props.title ? (
      <SidePanelSection title={props.title}>
        <P2GBox>
          {props.children && <P2GBox mb={2}>{props.children}</P2GBox>}
          <LabelLinks {...props} links={props.links} isParent={true} />
        </P2GBox>
      </SidePanelSection>
    ) : (
      <P2GBox>
        <P2GBox>
          {props.children && <P2GBox mb={2}>{props.children}</P2GBox>}
          <LabelLinks {...props} links={props.links} isParent={true} />
        </P2GBox>
      </P2GBox>
    );
  }

  return props.title ? (
    <SidePanelSection title={props.title}>
      <P2GBox>
        {props.children && <P2GBox mb={2}>{props.children}</P2GBox>}
        <LinksInner {...props} links={props.links} />
      </P2GBox>
    </SidePanelSection>
  ) : (
    <P2GBox>
      <P2GBox>
        {props.children && <P2GBox mb={2}>{props.children}</P2GBox>}
        <LinksInner {...props} links={props.links} />
      </P2GBox>
    </P2GBox>
  );
};

const AsyncLinks: React.FC<props> = (props) => {
  const links = props.links?.filter((x) => !!x)?.filter((x) => !props.match || !!props.match(x));

  if (!links || links.length === 0) {
    return null;
  }

  return props.wrapper ? props.wrapper(<Inner {...props} links={links} />) : <Inner {...props} links={links} />;
};

export { AsyncLinks };
